<template>
  <div>
    <v-layout justify-center>
      <v-flex>
        <v-card ref="form">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              <span v-if="!!id">Изменить отзыв организации</span>
              <span v-else> <div>Создать отзыв организации</div></span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-toolbar-items>
                <v-btn @click="closeDialog" class="pa-0 ma-0" dark flat icon>
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>

            <v-autocomplete
              :error="hasError('organization')"
              :error-messages="getError('organization')"
              :items="selectors.organization"
              label="Организация"
              v-model="value.organization"
              no-data-text ="Нет данных"
            >
              <template v-slot:prepend-item>
                <v-list-tile
                  ripple
                  @click="addOrganization = true"
                >
                  <v-list-tile-action>
                    <v-icon>add</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Добавить новую организацию</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-autocomplete>
            <v-autocomplete
              :disabled="disableCandidateCase"
              :error="hasError('candidateCase')"
              :error-messages="getError('candidateCase')"
              :items="selectors.candidateCase"
              label="Аттестационное дело соискателя"
              v-model="value.candidateCase"
              no-data-text ="Нет данных"
            ></v-autocomplete>

            <v-autocomplete
              :error="hasError('reviewType')"
              :error-messages="getError('reviewType')"
              :items="selectors.reviewType"
              label="Тип документа для отзыва"
              v-model="value.reviewType"
              no-data-text ="Нет данных"
            ></v-autocomplete>

            <v-dialog @input="loadAddOrganization" v-model="addOrganization" width="500" persistent>
              <Organization @addItem="loadAddOrganization"
                      @ended="addOrganization = false"
                      @refreshItem="loadAddOrganization"
                      v-if="addOrganization"
              >
              </Organization>
            </v-dialog>

            <FileInput
              v-bind:fieldLabel="'отзыв'"
              v-bind:field="'review'"
              @updateFile="updateFile"
              v-bind:file=value.review
              v-bind:error="hasError('review')"
              v-bind:error_messages="getError('review')"
            ></FileInput>
            <v-alert
              :value="hasError('detail')"
              type="error"
            >
              {{getError('detail')}}
            </v-alert>
            <v-btn @click="apply" color="primary">Сохранить</v-btn>
          </v-card-text>

          <v-divider class="mt-5"></v-divider>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import UserDataFormMixin from '../../../../../mixins/UserDataFormMixin'
  import {makeGetRequest, makePostRequestFile} from "../../../../../helper";
  import FileInput from "../../../../diss/components/FileInput"
  import Organization from "./Organization"
  export default {
    name: "Review_organization",
    props: [
      "id","organization","candidateCase","reviewType","review","disable",
    ],
    mixins: [UserDataFormMixin],
    components: {FileInput,Organization},

    data() {
      return {
        addOrganization:false,
        typeRew:1,
        URL_CREATE: process.env.VUE_APP_API_HOST +"council/admin/case/models/review_organization/",
        URL_UPDATE:  process.env.VUE_APP_API_HOST +"council/admin/case/models/review_organization/<id>/",
        selectors:{
          candidateCase: [],
          organization: [],
          reviewType: [],
        },
        disableCandidateCase : this.disable || false,
        value: {
          id: this.id || '',
          candidateCase: this.candidateCase || undefined,
          organization: this.organization || undefined,
          review: this.review ||null,
          reviewType: this.reviewType || undefined,
        },
      }
    },
    created() {
      if (this.disable){
        if (this.$route.params.id)
          this.value.candidateCase = Number(this.$route.params.id)
      }

      let url =  process.env.VUE_APP_API_HOST +"council/admin/core/selectors/organization/"
      this.load(this, url,'organization')

      url =  process.env.VUE_APP_API_HOST +"council/admin/case/selectors/candidate_case/"
      this.load(this, url,'candidateCase')

      url = process.env.VUE_APP_API_HOST +"council/admin/case/choices/doc_type_choices/"
      let sys = true
      makeGetRequest(url).then(resp => {
        if (!resp.ok) {
          sys = false
        }
        return resp.json()
      }) .then(json => {
        this.selectors.reviewType = json
      })
    },
    methods: {
      loadAddOrganization(){
        this.addOrganization = false;
        this.selectors.organization= [];
        let url =  process.env.VUE_APP_API_HOST +"council/admin/core/selectors/organization/"
        this.load(this, url,'organization')
      },
      updateFile(item) {
        this.value[item.field] = item.file;
      },
      closeDialog() {
        this.$emit('ended', '')
      },
      apply: function () {

        let url = this.URL_CREATE;
        let method = 'POST'

        if (this.id !== undefined) {
          method = 'PATCH'
          url = this.URL_UPDATE.replace('<id>', this.id);
        }

        let data = Object.assign({}, this.value);

        var formData = new FormData();

        for (var key in data) {
          if (data[key] !== undefined && data[key] !== null)
            if (key !== 'review')
              formData.append(key, data[key])
            else if (typeof data[key] !== "string")
              formData.append(key, data[key])
        }

        let status = true;
        makePostRequestFile(url, formData, method)
          .then(resp => {
            if (!resp.ok) {
              status = false;
            }
            return resp.json()
          })
          .then(json => {

            if (status) {
              this.$emit('addItem', json);
            } else {
              this.receiveErrors(json);
            }

          })

      },
      load: function (app, url,field) {
        if (url === null) {
          app.loadingPage = true;
          return;
        }
        makeGetRequest(url)
          .then(resp => resp.json())
          .then(json => {
            let next_url = null;
            if (json['next'] !== null)
              next_url = url.split('?')[0] + '?' + json['next'].split('?')[1];
            for (let i in json['results']) {
              app.selectors[field].push(Object.assign({}, json['results'][i]));
            }
            app.load(app, next_url,field);
          });
      },
      text: item => item.name[0].text,

    },
  }
</script>

<style scoped>

</style>
